import React from 'react';
import './Services.css';
import { SERVICES } from '../../utils/constants'; // Make sure SERVICES has blurHash property
import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Row, Col } from 'antd';
import { Card } from 'react-bootstrap';
import { BlurhashCanvas } from 'react-blurhash';

const OurServices = () => {
  const navigate = useNavigate();
  
  const handleServiceClick = (type) => {
    navigate(`/projects?type=${type}`);
  };

  return (
    <div className='services-page'>
      {/* Header Section */}
      <header className='services-header height-75'>
        <div className='container h-100 min-vh-100 d-flex flex-column align-items-center justify-content-center text-light'>
          <h1 className='text-center fw-semibold lspacing-10'>Our Services</h1>
          <h3 className='text-center w-100 mb-5 lspacing-10'>
          Excellence In Every Line, Space, and Foundation
          </h3>
        </div>
      </header>

      {/* Services Section */}
      <div className='container py-5 mt-5'>
        <Row style={{ width: '100%'}} justify="center" className='services_wrapper_cont'>
          {SERVICES.map((service, index) => (
            <Col
              key={service.id}
              xs={24} sm={12} md={8} lg={8} xl={6}
              onClick={() => handleServiceClick(service.title)}
              className={`${index % 2 !== 0 ? 'offset-down' : ''}`}
            >
              <Card className='service-card shadow'>
                <div className='service-image-wrapper' style={{ position: 'relative', height: '400px' }}>
                  <BlurhashCanvas
                    hash={service.blurHash}
                    punch={1}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                    }}
                    data-id={`blurhash-${service.id}`}
                  />
                  <LazyLoadImage
                    src={service.img}
                    alt={service.title}
                    height={400}
                    effect="blur"
                    className='service-image'
                    style={{ top: 0, left: 0, objectFit: 'cover' }}
                    onLoad={() => {
                      const blurHashElement = document.querySelector(`[data-id="blurhash-${service.id}"]`);
                      if (blurHashElement) {
                          blurHashElement.style.display = 'none';
                      }
                    }}
                  />
                  <div className='service-number'>0{index + 1}</div>
                </div>
                <Card.Body className='service-card-body dark-bg'>
                  <Card.Title className='service-title'>{service.title}</Card.Title>
                  <Card.Text className='dark-bg'>{service.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default OurServices;
